import { RootState } from 'redux/types';

export const getIsEditionBlocked = (root: RootState) => root.UI.isEditionBlocked;
